<template>
    <div class="my-finance-deposit">
        <div class="warnTip">
            {{ $t("rechargePage.tipsMoney") }}
        </div>
        <div class="rechange">
            <div class="tabs">
                <div
                    class="item-tabs buttonHover2"
                    :class="{ tabsAvitied: tabIndex == 0 }"
                    @click="ontabsChange(0)"
                >
                    {{ $t("rechargePage.setparagraph") }}
                </div>
                <div
                    class="item-tabs buttonHover2"
                    :class="{ tabsAvitied: tabIndex == 1 }"
                    @click="ontabsChange(1)"
                >
                    {{ $t("rechargePage.online") }}
                </div>
                <div
                    class="item-tabs buttonHover2"
                    :class="{ tabsAvitied: tabIndex == 2 }"
                    @click="ontabsChange(2)"
                    v-if="listPayWays.digit.length > 0"
                >
                    {{ $t("rechargePage.currency") }}
                </div>
                <div
                    class="item-tabs buttonHover2"
                    :class="{ tabsAvitied: tabIndex == 3 }"
                    @click="ontabsChange(3)"
                    v-if="listPayWays.vips.length > 0"
                >
                    {{ $t("rechargePage.vip") }}
                </div>
            </div>

            <div v-if="moneyModeList.length > 0 && moneyModeListReqSuccess">
                <div class="card">
                    <div class="flexItem">
                        <div class="flexName">
                            {{ $t("rechargePage.passageway") }}
                        </div>
                        <div class="felxg">
                            <div class="modelBox">
                                <div
                                    class="modelItem"
                                    v-for="(item, i) of moneyModeList"
                                    :key="i"
                                    @click="onChaneMoney(item, i)"
                                    :class="{ selectMode: modelIndex == i }"
                                >
                                    <img loading="lazy"
                                        v-lazy="$common.getImgUrl(item.icon)"
                                        class="model-img"
                                    />
                                    <div class="recharge-promotion" v-show="item.scale>0">
                                        <span class="recharge-promotion__text">赠送{{item.scale * 100}}%</span>
                                    </div>
                                    <span class="modelName">{{
                                        item.name
                                    }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="items1"
                    v-if="moneyType != 'currency' && moneyType != 'vip'"
                >
                    <div class="flexItem" v-if="moneyType != 'union'">
                        <div class="flexName">
                            {{ $t("rechargePage.passageway") }}
                        </div>
                        <div class="felxg">
                            <a class="markA" :href="channelItem.titleLink" v-show="channelItem.titleLink&&channelItem.titleState === 1" target="_blank">
                                <img src="@/assets/images/my/mark.png" />
                                <span>{{ channelItem.title }}</span>
                            </a>
                            <div class="aisleFlex">
                                <div
                                    v-for="(item, i) of channels"
                                    :key="i"
                                    @click="onChangeC(item, i)"
                                >
                                    <img loading="lazy"
                                        v-lazy="require('../../../assets/images/dze/xuanzhon.png')"
                                        v-if="isLabelIndex == i"
                                        class="selectimg"
                                        alt=""
                                    />
                                    <img loading="lazy"
                                        v-lazy="require('../../../assets/images/dze/unchange.png')"
                                        v-if="isLabelIndex != i"
                                        class="selectimg"
                                        alt=""
                                    />
                                    <p class="aisleName">{{ item.name }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flexItem" v-if="moneyType == 'union'">
                        <div class="flexName">
                            {{ $t("rechargePage.seleBank") }}:
                        </div>
                        <div class="felxg">
                            <el-select
                                v-model="selectBankname"
                                :placeholder="$t('rechargePage.bankSelect')"
                                class="select-list"
                                size="medium"
                                @change="onSelectBank"
                            >
                                <el-option
                                    v-for="(item, index) in unionlists"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="index"
                                    class="select-item"
                                >
                                    <span style="float: left">{{
                                        item.name
                                    }}</span>
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="flexItem" v-if="online == 1">
                        <div class="flexName">
                            {{channelItem.paytype ==='USDT' ?  $t("rechargePage.address") : $t("rechargePage.name") }}:
                        </div>
                        <div class="felxg">
                            <el-input
                                class="inputsele"
                                :placeholder="channelItem.paytype ==='USDT' ? $t('rechargePage.addressPlaceholder') : $t('rechargePage.inputName')"
                                v-model="bankname"
                            ></el-input>
                            <div class="tips">
                                {{ channelItem.paytype ==='USDT' ? $t("rechargePage.tipsAddress") : $t("rechargePage.tipsName")}}
                            </div>
                        </div>
                    </div>
                    <div class="flexItem" v-if="!input_money">
                        <div class="flexName">
                            {{ $t("rechargePage.setmoney") }}:
                        </div>
                        <div class="felxg">
                            <el-input
                                class="inputsele"
                                v-model="setMoney"
                                :placeholder="$t('rechargePage.inputMoney')"
                            ></el-input>
                            <div class="tips">
                                {{ $t("rechargePage.minMoney") }}
                                {{ moneyListRadio[0] }}
                                {{ $t("rechargePage.element") }};{{
                                    $t("rechargePage.maxMoney")
                                }}
                                {{ moneyListRadio[1] }}
                                {{ $t("rechargePage.element") }}
                            </div>
                        </div>
                    </div>
                    <div class="flexItem" v-if="input_money">
                        <div class="flexName">
                            {{ $t("rechargePage.setmoney") }}:
                        </div>
                        <div class="felxg radioBox">
                            <div
                                class="radio-btn"
                                v-for="(item, i) of moneyListRadio"
                                :key="i"
                                :class="{
                                    'radio-active': i == radioMoneyIndex,
                                }"
                                @click="onChangeMoneyBtn(i)"
                            >
                                {{ item }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="moneyType == 'currency' || moneyType == 'vip'">
                    <div class="flexItem">
                        <div class="flexName">
                            {{ $t("rechargePage.passageway") }}:
                        </div>
                        <div class="felxg">
                            <div class="aisleFlex">
                                <div
                                    v-for="(item, i) of channels"
                                    :key="i"
                                    @click="onChangeC(item, i)"
                                >
                                    <img loading="lazy"
                                        v-lazy="require('../../../assets/images/dze/xuanzhon.png')"
                                        v-if="isLabelIndex == i"
                                        class="selectimg"
                                        alt=""
                                    />
                                    <img loading="lazy"
                                        v-lazy="require('../../../assets/images/dze/unchange.png')"
                                        v-if="isLabelIndex != i"
                                        class="selectimg"
                                        alt=""
                                    />
                                    <p class="aisleName">{{ item.name }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tips-sz">
                        <p>{{ $t("rechargePage.tipstitle") }}:</p>
                        <p>
                            {{ $t("rechargePage.tips1") }}
                        </p>

                        <p>
                            {{ $t("rechargePage.tips2") }}
                        </p>
                        <p>
                            {{ $t("rechargePage.tips3") }}
                        </p>
                        <p>
                            {{ $t("rechargePage.tips4") }}
                        </p>
                    </div>
                </div>

                <div class="btnBox">
                    <el-button round class="btn buttonHover1" @click="checkSms">
                        {{ $t("rechargePage.next") }}
                    </el-button>
                </div>
            </div>
            <div
                class="null-box"
                v-if="moneyModeList.length == 0 && moneyModeListReqSuccess"
            >
                <!-- <img loading="lazy" src="../../assets/image/xf/null.png" class="null-img" alt="" /> -->
                <p class="null-text">{{ $t("rechargePage.null") }}</p>
                <p class="null-text">温馨提示：更多充值渠道请选择手机端和手机APP</p>
            </div>

            <el-dialog
                :visible.sync="dialogVisible"
                width="25%"
                class="dialogs"
            >
                <div slot="title" class="dialogHeader">
                    {{ $t("rechargePage.tipstitle") }}
                </div>
                <div class="dialogCentent">
                    <div class="dialogText">
                        {{ dialogText }}
                    </div>
                    <div
                        class="dialogBtn buttonHover1"
                        @click="dialogVisible = false"
                    >
                        {{ $t("rechargePage.determine") }}
                    </div>
                </div>
                <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span> -->
            </el-dialog>
        </div>

        <!-- 充值验证码 -->
        <el-dialog :visible.sync="dialogVisibleSms" width="500px" class="dialog">
            <div slot="title" class="header-title">
                请验证手机号充值
            </div>
            <div class="content">
                <div class="inputfelx">
                    <div class="label">{{ $t("accountPage.phone") }}</div>
                    <div class="input-p">
                        <el-input
                            v-model="mPhone"
                            :disabled="showPhone"
                            :placeholder="$t('accountPage.inputPhone')"
                        ></el-input>
                        <span v-if="showPhone" style="display:inline-block;padding:4px 20px;position:relative;top:-30px;background-color:rgb(245 247 250);left:4px;">{{showPhoneText}}</span>
                    </div>
                </div>
                <div class="inputfelx">
                    <div class="label">{{ $t("accountPage.code") }}</div>
                    <div>
                        <el-input
                            v-model="mCode"
                            :placeholder="$t('accountPage.inputcode')"
                        ></el-input>
                    </div>
                    <el-button class="btn-code" @click="getSmsCode" :loading="loading">
                        {{ smsCoolDown ? (smsCoolDown + 's') : '获取验证码' }}
                    </el-button>
                </div>
                <div>
                    <el-button class="btn-submit" @click="submitPhone" :loading="loading">
                        {{ $t("accountPage.determine") }}</el-button
                    >
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            tabIndex: 0,
            aisleIndex: 0,
            dialogVisible: false,
            listPayWays: {
                digit: [],
                vips: [],
            },
            moneyModeList: [],
            moneyListRadio: [], //单选金额
            moneyType: "", //选中当前存款方式类型
            channels: [], //当前通道
            isLabelIndex: 0, //通道下标
            channelItem: {}, //选中的通道
            online: 0, //为1,线下显示存款姓名
            unionlists: [], //选择银行卡
            input_money: Boolean, //输入或者单选金额
            setMoney: "", //存款金额
            bankname: "", //存款姓名
            modelIndex: 0,
            radioMoneyIndex: 0,
            selectBankname: "",
            moneyModeListReqSuccess: false,
            dialogText: "",

            smsCheck: false, // 是否需要短信验证
            dialogVisibleSms: false,
            mPhone: '', // 手机号
            mCode: '', // 验证码
            showPhone: false,// 是否已经有电话号码了
            smsCoolDown: 0,
            smsInterval: 0,
        };
    },
    created() {
        this.getMoneyMode();
        this.getSettings()
    },
    computed: {
        ...mapGetters(["userInfo"]),
        showPhoneText () {
            if (this.userInfo && this.userInfo.phone) {
                return this.userInfo.phone.substr(0, 3) + '****' + this.userInfo.phone.substr(-4, 4)
            }
            return ''
        }
    },
    methods: {
        // 获取配置
        getSettings () {
            this.loading = true
            this.$http.get(this.$api.getSettings, 'withdraw_open').then(res => {
                this.loading = false
                if (res && res.data && res.data.svalue && res.data.svalue.recharge_sms) {
                    this.smsCheck = true
                }
            })
        },
        // 获取验证码
        getSmsCode () {
            if (!this.mPhone) return this.$message.warning('请输入手机号');
            if (this.showPhone === false) {
                if (!/^1[3456789]\d{9}$/.test(this.mPhone)) {
                    this.$message.error(this.$t("accountPage.phoneErr"));
                    // this.phoneTips = "手机号格式错误";
                    return;
                }
            }
            this.loading = true
            this.$http
                .get(
                    this.$api.sendSmsCode +
                        "/" +
                        this.mPhone +
                        "?functionId=" +
                        3
                )
                .then((res) => {
                    this.loading = false
                    if (res.code == 0) {
                        this.$message.success(
                            this.$t("accountPage.getcodeSuee")
                        );
                        this.smsCoolDown = 59
                        this.smsInterval = setInterval(() => {
                            this.smsCoolDown--
                            if (this.smsCoolDown <= 0) {
                                clearInterval(this.smsInterval)
                            }
                        }, 1000)
                    } else {
                        this.$message.error(res.msg);
                    }
                });
        },
        // 绑定手机
        submitPhone() {
            let option = {
                phone: this.mPhone,
                smsCode: this.mCode,
            };
            this.loading = true
            this.$http.post(this.$api.bindPhone, option, true).then((res) => {
                this.loading = false
                if (res.code == 0) {
                    this.$message.success(this.$t("accountPage.mobile"));
                    this.dialogVisibleSms = false;
                    this.onSubmit()
                    this.$nkhttp.getUserInfo()
                } else {
                    let msg =
                        this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
                        this.$t("errorCode.webDefault");
                    this.$message.error(msg);
                }
            });
        },
        // 短信验证
        checkSms () {
            console.log('个人信息', this.userInfo)
            if (this.smsCheck && !(this.userInfo && this.userInfo.bindPhone)) {
                if (this.userInfo.phone) {
                    this.mPhone = this.userInfo.phone
                    this.showPhone = true
                }
                this.dialogVisibleSms = true
                return
            }
            this.onSubmit()
        },

        //获取付款方式
        getMoneyMode() {
            var data = {
                terminal: 1,
                version: 1,
            };
            this.$http
                .post(this.$api.getlistPayWays, data, true)
                .then((res) => {
                    if (res.code == 0) {
                        this.moneyModeListReqSuccess = true;
                        this.listPayWays = res.data;
                        if (this.listPayWays.offline.length > 0) {
                            this.tabIndex = 0;
                            this.moneyModeList = this.listPayWays.offline;
                        } else if (this.listPayWays.online.length > 0) {
                            this.tabIndex = 1;
                            this.moneyModeList = this.listPayWays.online;
                        } else if (this.listPayWays.digit.length > 0) {
                            this.tabIndex = 2;
                            this.moneyModeList = this.listPayWays.digit;
                        } else if (this.listPayWays.vips.length > 0) {
                            this.tabIndex = 3;
                            this.moneyModeList = this.listPayWays.vips;
                        }

                        //默认选中第一个
                        this.ontabsChange(0);
                    } else {
                        this.moneyModeListReqSuccess = false;
                        this.$message.error(this.$t("rechargePage.errortext"));
                    }
                });
        },
        ontabsChange(e) {
            this.tabIndex = e;
            if (this.tabIndex == 0) {
                this.moneyModeList = this.listPayWays.offline;
            } else if (this.tabIndex == 1) {
                this.moneyModeList = this.listPayWays.online;
            } else if (this.tabIndex == 2) {
                this.moneyModeList = this.listPayWays.digit;
            } else if (this.tabIndex == 3) {
                this.moneyModeList = this.listPayWays.vips;
            }
            if (this.tabIndex == 2 || this.tabIndex == 3) {
                this.dialogText =
                    this.$t("rechargePage.tips1") +
                    "\n" +
                    this.$t("rechargePage.tips2") +
                    "\n" +
                    this.$t("rechargePage.tips3");
                this.dialogVisible = true;
            }
            this.onChaneMoney(this.moneyModeList[0], 0);
        },
        //	切换存款方式
        onChaneMoney(item, i) {
            this.isLabelIndex = 0;
            this.radioMoneyIndex = 0;
            this.bankname = "";
            this.modelIndex = i;
            if (item){
                this.moneyType = item.code;
                this.channels = item.channels;
                this.onChangeC(this.channels[0], 0);

                if (item.code == "union") {
                    this.unionlists = item.channels;
                    this.selectBankname = item.channels[0].name;
                }
                if (item.code == "currency") {
                    this.sellrate = item.channels[0].exchangerate;
                }
            }
        },
        //选择通道
        onChangeC(item, i) {
            this.isLabelIndex = i;
            this.channelItem = item;
            this.online = item.online;
            var amountstr = item.amount;
            this.input_money = amountstr.indexOf(",") != -1 ? true : false;
            amountstr = amountstr.replace(/\[|]/g, "");
            if (this.input_money) {
                let arr = amountstr.split(",");

                var r = arr.filter(function (s) {
                    return s && s.trim(); // 注：IE9(不包含IE9)以下的版本没有trim()方法
                });
                this.moneyListRadio = r;
                this.setMoney = this.moneyListRadio[0];
            } else {
                this.setMoney = "";
                this.moneyListRadio = amountstr.split("-");
            }
            if (this.channelItem.remark && this.moneyType != "currency") {
                this.dialogText = this.channelItem.remark;
                this.dialogVisible = true;
            }
        },
        //选择固定金额
        onChangeMoneyBtn(i) {
            this.radioMoneyIndex = i;
            this.setMoney = this.moneyListRadio[i];
        },
        //选择银行卡
        onSelectBank(e) {
            this.onChangeC(this.channels[e], 0);
        },
        onAisleChange(e) {
            this.aisleIndex = this.aisleIndex == 0 ? 1 : 0;
        },
        onSubmit() {
            if (this.moneyType == "vip") {
                window.open(this.channelItem.vendorcode, "_blank");
                return;
            }
            if (this.online == 1 && !this.bankname) {
                let msg = this.channelItem.paytype === 'USDT' ? this.$t('rechargePage.addressPlaceholder') : this.$t("rechargePage.inputName")
                this.$message.error(msg);
                return;
            }
            if (!this.input_money && this.moneyType != "currency") {
                var min = parseInt(this.moneyListRadio[0]);
                var max = parseInt(this.moneyListRadio[1]);
                if (this.setMoney < min || this.setMoney > max) {
                    this.$message.error(this.$t("rechargePage.range"));
                    return;
                }
            }
            var data = {
                money: this.setMoney, //			入款金额
                online: this.channelItem.online, //	支付模式
                channelId: this.channelItem.id, //	充值通道
                payType: this.channelItem.paytype, //	支付方式
                terminal: "1", //	终端类型 //	终端类型 1.pc端, 11.原生android, 12.原生ios, 13.h5的android, 14.h5的ios
                vendorcode: this.channelItem.vendorcode,
                vendorname: this.channelItem.vendorname,
                vendorNickName: this.channelItem.name,
                transferName: this.bankname,
            };

            if (this.tabIndex == 0 && data.payType === 'union') { // 公司入款跳转内链
                this.$http.post(this.$api.getPaymentNextStep, data).then((res) => {
                    if (res.code == 0) {
                        const query = res.data.url.split('?')[1]
                        this.$router.push({
                            name: 'bankRecharge',
                            query: {
                                query: query
                            }
                        })
                    } else {
                        this.$alert(
                            this.$t("rechargePage.errortext"),
                            this.$t("rechargePage.tipstitle"),
                            {
                                confirmButtonText: this.$t(
                                    "rechargePage.determine"
                                ),
                                confirmButtonClass: "",
                                callback: (action) => {
                                    this.getMoneyMode();
                                },
                            }
                        );
                    }
                });
                return
            }

            this.$http.post(this.$api.getPaymentNextStep, data).then((res) => {
                if (res.code == 0) {
                    window.open(res.data.url, "_blank");
                } else {
                    this.$alert(
                        this.$t("rechargePage.errortext"),
                        this.$t("rechargePage.tipstitle"),
                        {
                            confirmButtonText: this.$t(
                                "rechargePage.determine"
                            ),
                            confirmButtonClass: "",
                            callback: (action) => {
                                this.getMoneyMode();
                            },
                        }
                    );
                }
            });
        },
    },
    beforeDestroy() {
		if (this.smsInterval) {
            clearInterval(this.smsInterval)
        }
	}
};
</script>
<style lang="scss" >
    @import url('../../../assets/css/common.css');
.my-finance-deposit {
    .rechange {
        .dialogs {
            .el-dialog__headerbtn .el-dialog__close {
                font-size: 0.2rem !important;
                color: #313131 !important;
            }
            .el-dialog__header {
                background: #ecf0f3;
            }
            .el-dialog__body {
                padding: 0px;
            }
        }

        .dialogHeader {
            color: #313131;
            font-size: 24px;
            text-align: center;
            padding-top: 10px;
            font-weight: 600;
        }
        .dialogCentent {
            padding: 20px 45px 45px 45px;
            background: #ecf0f3;
            .dialogText {
                font-size: 14px;
                color: #313131;
                opacity: 0.6;
                margin-bottom: 45px;
                white-space: break-spaces;
                text-align: center;
            }
            .dialogBtn {
                text-align: center;
                font-size: 16px;
                border-radius: 10px;
                padding: 10px 30px;
                margin-right: 20px;
                width: 30%;
                margin-left: 30%;
                background: #ff3a2b;
                font-weight: bold;
                color: #fff;
                cursor: pointer;
            }
        }
        .tips-sz {
            color: #313131;
            font-size: 14px;
            margin: 30px 0;
        }
        .header {
            color: #3e444d;
            font-size: 30px;
            margin-bottom: 30px;
            font-weight: bold;
        }

        .card {
            margin: 30px 0;
            .modelBox {
                display: flex;
                flex-wrap: wrap;
                margin-top: 20px;

                .modelItem {
                    background: #fff;
                    border: 1px solid #dcdcdc;
                    -webkit-box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.05);
                    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.05);
                    margin: 4px 10px 4px 0;
                    border-radius: 0;
                    cursor: pointer;
                    color: #333;
                    width: 180px;
                    height: 56px;
                    line-height: 56px;
                    position: relative;
                    text-align: center;
                    .model-img {
                        width: 36px;
                        height: 36px;
                        margin: 0 10px;
                    }
                    .modelName {
                        color: #313131;
                        font-size: 14px;
                    }
                    .recharge-promotion {
                        width: 60px;
                        height: 56px;
                        position: absolute;
                        top: 0;
                        left: 0;
                        white-space: nowrap;
                        background-image: url("../../../assets/images/xf/jiaobiao_bg_pc.png");
                        background-size: cover;
                        background-repeat: no-repeat;
                        text-align: left;
                        letter-spacing:-1px;
                        .recharge-promotion__text{
                            width: 100%;
                            height: 100%;
                            text-align: center;
                            line-height: 32px;
                            color: #FFF;
                            font-size: 12px;
                            transform: rotate(319deg);
                            position: absolute;
                        }
                    }
                }
                .selectMode {
                    border: 1px solid #2acc65;
                    box-shadow: 0 0 4px #69ec98;
                    background-image: url("../../../assets/images/xf/jiaobiao_dui_PC.png");
                    background-size: 30px 30px;
                    background-repeat: no-repeat;
                    background-position: right bottom;
                }
            }
        }
        .items1 {
            margin-top: 30px;
        }
        .tabs {
            display: flex;
            .item-tabs {
                text-align: center;
                font-size: 16px;
                color: #313131;
                padding: 10px 40px;
                margin-right: 20px;
                // background: url("../../assets/image/dze/btnbgw.png") no-repeat;
                background-size: 100% 100%;
                font-weight: bold;
                cursor: pointer;
            }
            .tabsAvitied {
                border-bottom: 3px solid #ff3a2b;
            }
        }
        .flexItem {
            display: flex;
            margin-bottom: 30px;
            align-items: center;
            .flexName {
                color: #313131;
                font-size: 16px;
                width: 15%;
            }
            .aisleFlex {
                display: flex;
                .selectimg {
                    width: 20px;
                    height: 20px;
                    margin-right: 10px;
                    cursor: pointer;
                }
                .aisleName {
                    color: #313131;
                    font-size: 14px;
                    display: inline-block;
                    margin-right: 20px;
                    cursor: pointer;
                }
            }
            .inputsele {
                width: 4rem;
            }
            .felxg {
                // flex-grow: 2;
                .el-select {
                    width: 4rem;
                }
                .el-input__inner {
                    // background: #f9f9f9;
                    // border-color: #fdb753;
                    height: 0.4rem;
                }
                .el-input.is-active .el-input__inner,
                .el-input__inner:focus {
                    // border-color: #fdb753;
                    outline: 0;
                }
                .markA {
                    display: inline-block;
                    color: #fbb053;
                    margin-bottom: 5px;
                    img {
                        width: 15px;
                        height: 15px;
                        margin-right: 5px;
                    }
                }
            }
            .radioBox {
                display: flex;
                flex-wrap: wrap;
                flex: 1;
            }
            .radio-btn {
                // background: url("../../assets/image/dze/btnbgw.png") no-repeat;
                // background-size: 100% 100%;
                border: 1px solid #ebe6e0;
                color: #313131;
                width: 1.2rem;
                margin-right: 0.2rem;
                margin-bottom: 0.1rem;
                margin-top: 0.1rem;
                height: 0.4rem;
                text-align: center;
                line-height: 0.4rem;
                border-radius: 6px;
                cursor: pointer;
            }
            .radio-active {
                background: none;
                // background-size: 100% 100%;
                font-weight: bold;
                color: #ff3a2b;
                border: 1px solid #ff3a2b;
            }
            .tips {
                color: #db4e4e;
                font-size: 14px;
            }
        }

        .btnBox {
            margin-left: 15%;
            .btn {
                color: #fff;
                width: 1.28rem;
                border-radius: 4px;
                text-align: center;
                line-height: 40px;
                cursor: pointer;
                display: inline-block;
                background: #ff3a2b;
                padding: 0px !important;
            }
        }
        .null-box {
            margin-left: 25%;
            margin-top: 0.5rem;
            .null-img {
                width: 1.5rem;
                height: 2rem;
            }
            .null-text {
                color: #313131;
                font-size: 0.2rem;
                margin-top: 0.2rem;
            }
        }
    }
}
</style>
<style lang="scss" scoped>
.dialog {
    .el-dialog__headerbtn .el-dialog__close {
        // font-size: 0.2rem !important;
        color: #313131 !important;
    }
    .el-dialog__header {
        padding: 20px 20px 10px;
    }
    .customClass {
        .el-loading-text {
            background: #000;
            color: #fff;
            font-size: 0.2rem;
        }
    }
    .el-dialog__body {
        padding: 0;
    }
    .header-title {
        text-align: center;
        color: #2d2b4d;
        font-size: 28px;

        font-weight: bold;
    }
    .content {
        padding: 20px 60px;
        .btn-submit {
            width: 100%;
            font-size: 16px;
            border: none;
            color: #fff;
            background: #ff3a2b;
            border-radius: 10px;
            margin-top: 0.4rem;
        }
        .btn-code {
            color: #fff;
            font-size: 16px;
            border: none;
            background: #ff3a2b;
            border-radius: 10px;
        }
    }
    .inputfelx {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .label {
            color: #2d2b4d;
            font-size: 16px;
            white-space: nowrap;
            width: 75px;
            flex-shrink: 0;
        }
        .input-p {
            flex-grow: 2;
        }
        .btn-code {
            margin-left: 10px;
            width: 1.5rem;
        }
    }
}
</style>